import { ADD_PRODUCT, DELETE_CART, MANAGE_QUANTITY, } from "./actionTypes"


export const addProduct = (data) => {
    return {
        type: ADD_PRODUCT,
        payload: data
    }
}
export const manageQuantity = ({ id, type = 'increase' }) => {
    return {
        type: MANAGE_QUANTITY,
        payload: { id, type }
    }
}
export const deleteCart = (id) => {
    return {
        type: DELETE_CART,
        payload: id
    }
}
